const parseBase64 = <T = any>(encodedString: string): T => {
  return JSON.parse(window.atob(encodedString));
};

export default parseBase64;
